import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconAirplayStyle0 = cosmosIconCss;

const CosmosIconAirplay$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconAirplay extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '9e95a35b78eab606e1d9718ba829154656c216f1', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a81355f0282930f521a0c352c0f6db9e47175e1a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '4b6cb99d197c4d557b89632478920f6f081ea04a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 4h17a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2.37a.48.48 0 0 1-.41-.22l-.35-.52a.48.48 0 0 1-.09-.26.5.5 0 0 1 .5-.5h1.72v-9h-15v9h1.64a.5.5 0 0 1 .5.5.51.51 0 0 1-.09.27l-.42.54a.51.51 0 0 1-.39.19H2.5a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5Zm13.488 14.733a.5.5 0 0 1-.438.267h-9.1a.5.5 0 0 1-.45-.78l4.59-6.62a.5.5 0 0 1 .82 0l4.55 6.62a.5.5 0 0 1 .028.513Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconAirplayStyle0; }
}, [1, "cosmos-icon-airplay", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-airplay"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-airplay":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconAirplay$1);
            }
            break;
    } });
}

const CosmosIconAirplay = CosmosIconAirplay$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconAirplay, defineCustomElement };
